import { render } from "./Oportunitati.vue?vue&type=template&id=24b87aba&scoped=true&ts=true"
import script from "./Oportunitati.vue?vue&type=script&lang=ts"
export * from "./Oportunitati.vue?vue&type=script&lang=ts"

import "./Oportunitati.vue?vue&type=style&index=0&id=24b87aba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b87aba"]])

export default __exports__